module.exports = __webpack_public_path__ + "static/img/mandiri.274d827.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mandiri.png
// module id = 2STr
// module chunks = 1